export default "__VITE_ASSET__DEz$1HgS__"